/********************************************************
 *                                                      *
 * -------------------- CONSTANTS --------------------- *
 *                                                      *
 ********************************************************/

export const DATA_NAMES = {
    CTA: 'a[data-cta-name], button[data-cta-name]',
    VIDEO: 'video[data-video-marketing-title]',
    FORM: 'form[data-form-name]',
    PAGE: ['/checkout'],
} as const;

export type DataName = keyof typeof DATA_NAMES;

export const EVENT_NAMES = {
    CTA: {
        generic: 'CTA Clicked',
        checkout: {
            trial: {
                step_completed: 'Trial Signup Step Completed',
                order_completed: 'Trial Order Completed',
            },
            step_completed: 'Checkout Step Completed',
        },
    },
    VIDEO: {
        marketing: {
            play: 'Marketing Video Started',
            ended: 'Marketing Video Completed',
        },
    },
    FORM: {
        submit: {
            generic: 'Form submitted',
            marketing: 'Marketing Opted In',
        },
        input: {
            trial: {
                credit_card: 'Trial Payment Info Entered',
            },
            checkout: {
                payment_info: 'Payment Info Entered',
            },
        },
    },
    PAGE: {
        checkout: {
            trial: {
                started: 'Trial Signup Started',
                step_viewed: 'Trial Signup Step Viewed',
            },
            started: 'Checkout Started',
            step_viewed: 'Checkout Step Viewed',
        },
    },
} as const;

export type EventName = keyof typeof EVENT_NAMES;

export const LOGS = {
    ERROR: {
        load: 'SegmentTracker: Load error',
        trial: {
            viewed: 'SegmentTracker: Error on page viewed. Product is empty',
            started: 'SegmentTracker: Error on Trial Started. Product is empty',
        },
    },
} as const;

export type Logs = keyof typeof LOGS;
